import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { removeMtrsFromContractChangeGql } from '../AgreementsQueries';

export const useRemoveAgreementsMtr = (
    contractChangeId: number,
    checkedAgreementsMtrIds: number[],
    refreshAgreementMtr: () => void,
    refreshFilters: () => void,
) => {
    const dispatch = useDispatch();

    const [
        removeMtrsContractChangeData,
        removeMtrsContractChangeStatus,
        removeMtrsContractChangeError,
        removeMtrsContractChangeRequest,
        removeMtrsContractChangeSetData,
    ] = useRequest({
        requestId: 'removeMtrsFromContractChange',
        query: removeMtrsFromContractChangeGql,
        withEffect: false,
    });

    const handleRemoveMtrsContractChange = useCallback(() => {
        dispatch(removeMtrsContractChangeRequest({ contractChangeId, mtrIds: checkedAgreementsMtrIds }));
    }, [checkedAgreementsMtrIds, contractChangeId, dispatch, removeMtrsContractChangeRequest]);

    useEffect(() => {
        if (
            removeMtrsContractChangeStatus === RequestStatus.SUCCESS &&
            removeMtrsContractChangeData?.uerRemoveMtrsFromContractChange?.result
        ) {
            refreshAgreementMtr();
            refreshFilters();
        }
    }, [
        refreshAgreementMtr,
        refreshFilters,
        removeMtrsContractChangeData?.uerRemoveMtrsFromContractChange?.result,
        removeMtrsContractChangeStatus,
    ]);

    return {
        removeMtrsContractChangeData: removeMtrsContractChangeData?.uerRemoveMtrsFromContractChange,
        removeMtrsContractChangeStatus,
        removeMtrsContractChangeError,
        removeMtrsContractChangeSetData,
        handleRemoveMtrsContractChange,
    };
};
